import axios from 'axios'
import { useAuthStore } from '../stores/auth'
import { ElMessage } from 'element-plus'

// 创建axios实例
const apiClient = axios.create({
  baseURL: (import.meta as any).env?.VITE_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 公开API客户端（无需认证）
export const publicClient = axios.create({
  baseURL: (import.meta as any).env?.VITE_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 公开API响应拦截器（只处理数据格式，不处理认证跳转）
publicClient.interceptors.response.use(
  (response) => {
    if (response.data && typeof response.data.success === 'boolean') {
      if (response.data.success) {
        return response.data.data
      } else {
        throw new Error(response.data.error?.message || 'Unknown error')
      }
    }
    return response.data
  },
  (error) => {
    const { response } = error
    if (response?.status === 429) {
      ElMessage.warning(response.data?.error?.message || 'Rate limit exceeded')
    } else if (response?.status >= 500) {
      ElMessage.error('Server error. Please try again later.')
    } else if (response) {
      ElMessage.error(response.data?.error?.message || 'An error occurred')
    } else {
      ElMessage.error('Network error. Please check your connection.')
    }
    return Promise.reject(error)
  }
)

// 请求拦截器
apiClient.interceptors.request.use(
  async (config) => {
    const authStore = useAuthStore()
    
    // 检查是否需要刷新 token（排除刷新token的请求本身）
    if (authStore.shouldRefreshToken() && !config.url?.includes('/auth/refresh')) {
      const refreshed = await authStore.refreshAccessToken()
      if (!refreshed) {
        // 刷新失败，跳转登录
        window.location.href = '/login'
        return Promise.reject(new Error('Token refresh failed'))
      }
    }
    
    if (authStore.token) {
      config.headers.Authorization = `Bearer ${authStore.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    // 如果响应格式是 { success: true, data: ... }
    if (response.data && typeof response.data.success === 'boolean') {
      if (response.data.success) {
        return response.data.data
      } else {
        throw new Error(response.data.error?.message || 'Unknown error')
      }
    }
    return response.data
  },
  (error) => {
    const { response } = error
    
    if (response) {
      switch (response.status) {
        case 401:
          // 未授权，清除token并跳转到登录
          const authStore = useAuthStore()
          authStore.logout()
          ElMessage.error('Session expired. Please login again.')
          window.location.href = '/login'
          break
          
        case 403:
          ElMessage.error(response.data?.error?.message || 'Access denied')
          break
          
        case 429:
          ElMessage.warning(response.data?.error?.message || 'Rate limit exceeded')
          break
          
        case 500:
          ElMessage.error('Server error. Please try again later.')
          break
          
        default:
          ElMessage.error(response.data?.error?.message || 'An error occurred')
      }
    } else {
      ElMessage.error('Network error. Please check your connection.')
    }
    
    return Promise.reject(error)
  }
)

export default apiClient
